import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ProductGrid from '../components/ProductGrid';
import axios from 'axios';

const Category = () => {

  const { categoryname, subcategoryname } = useParams();

  const [products, setProducts] = useState([]);

  useEffect(() => {
    async function filterSubcategoryId() {

      // Fetch all categories
      const response = await axios.get(process.env.REACT_APP_API_URL + 'product/categories');

      // Filter the category id
      const categoryId = response?.data?.categories.filter(category => category.name === categoryname)[0].id;

      // Fetch all subcategories with category Id
      const subcategoryresponse = await axios.get(process.env.REACT_APP_API_URL + 'product/allSubcategory');

      // Filter the subcategory
      const subcategory = subcategoryresponse?.data?.Subcategory.filter(
        subcategory => subcategory.categoryId === categoryId && subcategory.name === subcategoryname
      );

      const products = await getSubCategoryProducts(subcategory[0].id)

      setProducts(products)
    }

    filterSubcategoryId()
  }, [categoryname, subcategoryname])

  return (
    <div className='container mt-5 p-3'>
      <div className='row p-4 minHight'>
        <ProductGrid section={categoryname + '/' + subcategoryname} products={products} />
      </div>
    </div>
  );
};

export default Category;

export const getSubCategoryProducts = async (id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}product/subcategoryProducts/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error:', error);
  }
};